/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.security.scheduling-administrators'},
});

const SchedulingAdministratorsItem = () => (
  <RouteLinkItem
    route="midas/settings/security/scheduling-administrators"
    title={messages.title}
  />
);

export default SchedulingAdministratorsItem;
